import { NgModule } from '@angular/core';
import { AddMoneyComponent } from './add-money.component';
import { SharedModule } from '@shared/shared.module';
import { MatDialogCustomModule } from '../mat-dialog-custom/mat-dialog-custom.module';
import {
  NguCarousel,
  NguCarouselDefDirective,
  NguCarouselNextDirective,
  NguCarouselPrevDirective,
  NguItemComponent,
} from '@ngu/carousel';

@NgModule({
  declarations: [AddMoneyComponent],
  imports: [
    SharedModule,
    MatDialogCustomModule,
    NguCarousel,
    NguCarouselDefDirective,
    NguCarouselNextDirective,
    NguCarouselPrevDirective,
    NguItemComponent,
  ],
  exports: [AddMoneyComponent],
})
export class AddMoneyModule {}
